export interface ITerritory {
  org_id?: string
  name?: string
  province?: string
  terrunit: number
  terrunit_id: string
}

export class User {
  username: string
  password: string
  twoFactorAuth: boolean
  isAdmin: boolean
  email: string
  territories: ITerritory[]

  selected: boolean

  constructor(data: any = {}) {
    this.username = data.username || data.user_name || ''
    this.password = data.password || ''
    this.email = data.email || ''
    this.territories = data.territories || []
    this.twoFactorAuth = data.mfa_required || false
    this.selected = false
    this.isAdmin = data.is_admin || false
  }

  validate(isEdit = false): string[] {
    const errors = []

    if (!this.username) {
      errors.push({
        field: 'username',
        content: 'Required field',
      })
    } else if (!/^[a-z\d\-]*$/g.test(this.username)) {
      errors.push({
        field: 'username',
        content:
          'Only lower case letters, numbers and the dash (-) symbol are allowed',
      })
    }

    const MIN_PASSWORD_LENGTH = 6
    const MAX_PASSWORD_LENGTH = 64

    if (!isEdit && !this.password) {
      errors.push({
        field: 'password',
        content: 'Required field',
      })
    } else if (!isEdit && this.password.length < MIN_PASSWORD_LENGTH) {
      errors.push({
        field: 'password',
        content: 'Must be at least ' + MIN_PASSWORD_LENGTH + ' characters long',
      })
    } else if (!isEdit && this.password.length > MAX_PASSWORD_LENGTH) {
      errors.push({
        field: 'password',
        content: 'Must be at most ' + MAX_PASSWORD_LENGTH + ' characters long',
      })
    } else if (!isEdit && this.password === this.username) {
      errors.push({
        field: 'password',
        content: 'Password and username must be different',
      })
    } else if (
      !isEdit &&
      !/[\w !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]+/gi.test(this.password)
    ) {
      errors.push({
        field: 'password',
        content:
          'Must contain at least one special character (for example: .?!)',
      })
    }

    const EMAIL_REGEX =
      /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    if (!this.email) {
      errors.push({
        field: 'email',
        content: 'Required field',
      })
    } else if (!EMAIL_REGEX.test(this.email)) {
      errors.push({
        field: 'email',
        content: 'Wrong email format',
      })
    }

    if (!this.isAdmin && (!this.territories || this.territories.length === 0)) {
      errors.push({
        field: 'territories',
        content: 'You must select at least one location',
      })
    }

    return errors
  }

  toJSON() {
    const out = {
      user_name: this.username,
      email: this.email,
      password: this.password,
      mfa_required: this.twoFactorAuth,
      is_admin: this.isAdmin,
    }

    if (!this.password) {
      out['password'] = this.password
    }

    if (!this.isAdmin) {
      out['territories'] = this.territories
    }

    return out
  }
}
